module.exports = __webpack_public_path__ + "img/hr-rock-huge-10.59278e33.png";